import React, { ReactNode, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import styled, { CSSProperties } from "styled-components";

export const OverlayWrapper = styled.div`
  height: 100%;
  position: relative;

  .status-enter-active {
    opacity: 1;
    pointer-events: auto;
  }
  .status-enter-done {
    opacity: 1;
    pointer-events: auto;
  }
  .status-exit-active {
    opacity: 0;
    pointer-events: auto;
  }
  .status-exit-done {
    opacity: 0;
  }
`;

export const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const OverlayOverlay = styled.div<{
  show?: boolean;
}>`
  opacity: ${(props) => (props.show ? "1" : "0")};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transition: opacity 0.2s;
  pointer-events: none;
`;

const Overlay: React.FC<
  React.PropsWithChildren<
    React.ComponentProps<typeof OverlayWrapper> & {
      showOverlay?: boolean;
      overlayContent?: ReactNode;
      overlayStyle?: CSSProperties;
      overlayClassName?: string;
    }
  >
> = ({
  showOverlay,
  overlayContent,
  overlayStyle,
  overlayClassName,
  children,
  ...props
}) => {
  const ref = useRef(null);

  if (overlayStyle == null) {
    overlayStyle = {
      backdropFilter: "blur(1px)",
    };
  }

  return (
    <OverlayWrapper {...props}>
      {children}
      <CSSTransition
        classNames="status"
        timeout={200}
        in={!!showOverlay}
        nodeRef={ref}
      >
        <OverlayOverlay
          show={!!showOverlay}
          ref={ref}
          className={overlayClassName}
          style={overlayStyle}
        >
          <OverlayContent>{overlayContent}</OverlayContent>
        </OverlayOverlay>
      </CSSTransition>
    </OverlayWrapper>
  );
};

export default Overlay;
